export const IT: Record<string, string> = {
  "Recommended for you": "Consigliato per te",
  "Resource added to favorite": "Risorsa aggiunta ai preferiti",
  "Failed to add resource to favorite": "Impossibile aggiungere la risorsa ai preferiti",
  "Resource removed from favorite": "Risorsa rimossa dai preferiti",
  "Failed to remove resource from favorite": "Impossibile rimuovere la risorsa dai preferiti",
  "Calendar": "Calendario",
  "View Detail": "Visualizza dettagli",
  "Add to favorites": "Aggiungi ai preferiti",
  "Remove from favorites": "Rimuovi dai preferiti",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Descrizione: Sala riunioni VIP con una vista fantastica e sedie comode.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Non ci sono risorse disponibili all'orario scelto nella tua posizione o nei tuoi preferiti.",
  "You have these options:": "Hai queste opzioni:",
  "Change the meeting time.": "Modifica l'orario della riunione.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Usa il pulsante <1>Trova orario disponibile</1> per scegliere un nuovo orario.",
  "Open the search to find other resources.": "Apri la ricerca per trovare altre risorse.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Il tipo di risorsa <1>'{{resourceType}}'</1> non esiste nella tua posizione predefinita",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Il tipo di risorsa <1>'{{resourceType}}'</1> può essere trovato in una posizione differente.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Clicca qui</1> per aggiungere il tipo di risorsa alle tue impostazioni della posizione predefinita.",
  
  // ResourceCard
  "New Order": "Nuovo ordine",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Al prenotare un Pooled Resource, puoi prenotare solo questo tipo di risorsa e solo una risorsa.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Non puoi selezionare sia un risorsa figlia che il suo risorsa virtuale allo stesso tempo.",
  // Settings
  "Note:": "Nota:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Un organizzatore assistente può ricevere le stesse email da Resource Central come l'organizzatore e può gestire gli ordini per conto dell'organizzatore.",
  "Setting updated successfully": "Impostazione aggiornata con successo",
  "Setting updated failed": "Aggiornamento impostazione non riuscito",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 posto",
  "Opening hours:": "Orari di apertura:",
  "Buffer time {{minutes}} mins between reservations": "Tempo buffer {{minutes}} min tra le prenotazioni",
  "Initial payment {{value}} pr.minute": "Pagamento iniziale {{value}} al minuto",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Totale {{total}} partecipanti",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} su {{total}} interni possono partecipare.",
  "{{external}} external is unknown.": "{{external}} esterni sono sconosciuti.",
  "Find available time": "Trova orario disponibile",
  "Attendees": "Partecipanti",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Fai clic su Ulteriori informazioni per visitare il nostro sito di supporto",
  "Further information": "Ulteriori informazioni",
  
  // LocationSetting
  "Location changed": "Posizione modificata",
  "Location change failed": "Modifica posizione non riuscita",
  "Please select at least one location": "Seleziona almeno una posizione",
  "Resource types": "Tipi di risorse",
  "Location": "Posizione",
  "Where": "Dove",
  
  // ModalShowAttendees
  "Total": "Totale",
  "Available": "Disponibile",
  "Busy": "Occupato",
  "External": "Esterno",
  "Internal": "Interno",
  
  // ResourceSearch
  "Search by resource name": "Cerca per nome risorsa",
  "Category": "Categoria",
  "Filter by Location": "Filtra per posizione",
  "Filter by Category": "Filtra per categoria",
  "Capacity": "Capacità",
  "Filter by Capacity": "Filtra per capacità",
  "All": "Tutti",
  "Filter by availability": "Filtra per disponibilità",
  "Sort By": "Ordina per",
  "Loading...": "Caricamento...",
  
  // SelectedResources
  "Meeting Type": "Tipo di riunione",
  "Meeting Label": "Etichetta riunione",
  
  // Alert (accessibility text)
  "Check icon": "Icona di spunta",
  "Close": "Chiudi",
  
  // AppConstants - searchTab
  "Resource": "Risorsa",
  "Person": "Persona",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Dove si svolgono solitamente le tue riunioni?",
  "To improve our recommendations for you we would like you to enter your normal location": "Per migliorare i nostri consigli per te, vorremmo che inserissi la tua posizione abituale",
  "What do you use most?": "Cosa usi di più?",
  "To enable quicker and better search please chose you prefered resource type": "Per consentire una ricerca più rapida e migliore, scegli il tipo di risorsa preferito",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Clicca sulla risorsa per selezionare",
  "Selected Resources": "Risorse selezionate",
  "Setting": "Impostazione",
  "Search": "Cerca",
  "Find Colleague": "Trova collega",
  "Quick button setting": "Impostazione pulsante rapido",
  "Favorite": "Preferito",
  "Most Used": "Più utilizzati",
  "Colleagues": "Colleghi",
  "Resources": "Risorse",
  
  // AppConstants - tooltipText
  "Back": "Indietro",
  "Floor Plan": "Planimetria",
  "Expand": "Espandi",
  "Selected resources": "Risorse selezionate",
  "View details": "Visualizza dettagli",
  "Remove from My Favorites": "Rimuovi dai miei preferiti",
  "Add to My Favorites": "Aggiungi ai miei preferiti",
  "Remove": "Rimuovi",
  "Favorite - Most Used": "Preferito - Più utilizzati",
  "Conflict": "Conflitto",
  "Approved": "Approvato",
  "Recommendeded for you": "Consigliato per te",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Solo organizzatore principale",
  "Only assistant organizer": "Solo organizzatore assistente",
  "Primary AND assistant organizer": "Organizzatore principale E assistente",
  
  // FindColleague
  "Enter colleague name": "Inserisci nome collega",
  "Recent work items": "Elementi di lavoro recenti",
  "No data available": "Nessun dato disponibile",
  "Floorplan": "Planimetria",
  "List nearby resources": "Elenco risorse nelle vicinanze",
  "Find resource nearby": "Trova risorsa nelle vicinanze",
  "No Resources available": "Nessuna risorsa disponibile",
  
  // Start page
  "Next": "Avanti",
  "Failed to update default locations": "Impossibile aggiornare le posizioni predefinite",
  "Resource Type": "Tipo di risorsa",
  
  // QuickSetting
  "Quick buttons updated successfully": "Pulsanti rapidi aggiornati con successo",
  "Quick buttons updated failed": "Aggiornamento pulsanti rapidi non riuscito",
  "Add more": "Aggiungi altro",
  "Apply": "Applica",
  "Delete": "Elimina",
  "Name": "Nome",
  "Enter name": "Inserisci nome",
  "Tooltip": "Tooltip",
  "Enter tooltip": "Inserisci tooltip",
  "Type": "Tipo",
  "Select type": "Seleziona tipo",
  "Locations": "Posizioni",
  "Select colleagues": "Seleziona colleghi",
  "Select resources": "Seleziona risorse",
  
  // DefaultResourceSetting
  "Resource type changed": "Tipo di risorsa modificato",
  "Resource type change failed": "Modifica tipo di risorsa non riuscita",
  "Default Resource Type": "Tipo di risorsa predefinito",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Applicato con successo",
  "Apply Failed": "Applicazione non riuscita",
  "Assistant Organizer": "Organizzatore assistente",
  "Enter a part of the name to search for": "Inserisci parte del nome per cercare",
  "Mail Flow": "Flusso di posta",
  "Select Mail Flow": "Seleziona flusso di posta",
  
  // TileConfigurationSetting
  "Update settings successfully": "Impostazioni aggiornate con successo",
  "Update settings failed": "Aggiornamento impostazioni non riuscito",
  "Timeline": "Timeline",
  
  // SelectCategoryForm
  "And": "E",
  "Or": "O",
  
  // Other
  "Resource Calendar": "Calendario risorse",
  
  // SettingLabels
  "Default Location": "Posizione predefinita",
  "Quick button": "Pulsante rapido",
  "Category icons": "Icone categoria",
  "Recommendation screen": "Schermata raccomandazioni",
  "Capacity filter": "Filtro capacità",
  "AI Assistant": "Assistente AI",
  "Tile configuration": "Configurazione riquadri",
  "Help": "Aiuto",
  "Default Categories": "Categorie predefinite",
  
  // MeetingType
  "Your must select a Meeting label": "Devi selezionare un'etichetta per la riunione",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Risorsa selezionata: 'AOD_Copanhagen' Occorrenze in conflitto",
  "Alternative Resource": "Risorsa alternativa",
  "OK": "OK",
  "Cancel": "Annulla",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "La tua risorsa selezionata 'AOD_Copenhagen' è stata rimossa",
  "You can't book this resource as your request exceeds the available capacity.": "Non puoi prenotare questa risorsa poiché la tua richiesta supera la capacità disponibile.",
  
  // ChangeTime
  "Time changed successfully": "Orario modificato con successo",
  "Current Time": "Ora attuale",
  "Suggested Times": "Orari suggeriti",
  "Change Time": "Cambia orario",
  "people are free": "persone sono libere",
};

